const TOKEN_TTL_HOURS = 18;

/** Salva o token JWT em sessionStorage + localStorage com validade de 18h. */
export function saveToken(token) {
  sessionStorage.setItem('token', token);
  localStorage.setItem('token', token);

  const expiracao = new Date();
  expiracao.setHours(expiracao.getHours() + TOKEN_TTL_HOURS);
  sessionStorage.setItem('tokendatahora', expiracao.toISOString());
  localStorage.setItem('tokendatahora', expiracao.toISOString());
}

/** Retorna o token JWT atual (sessionStorage tem prioridade sobre localStorage). */
export function getToken() {
  return sessionStorage.getItem('token') || localStorage.getItem('token');
}

/** Verifica se o token expirou com base na marca de tempo salva por saveToken. */
export function isTokenExpired() {
  const tokenDataHora = sessionStorage.getItem('tokendatahora') || localStorage.getItem('tokendatahora');
  if (!tokenDataHora) return true;
  return new Date() > new Date(tokenDataHora);
}

const TokenService = { saveToken, getToken, isTokenExpired };

export default TokenService;
